import { AlertTriangle, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatHours } from './helpers';
import type { OverageAlertProps } from './types';

// Variable hours past the plan are billed, so a client over on them is the
// first thing the page says. The bill is drawn up once at month end, so each
// one leads to why it ran over. Nothing shows when no client is over.
export function OverageAlert({ clients, clientHref }: OverageAlertProps) {
  if (clients.length === 0) return null;

  return (
    <section
      aria-label="Variable overage"
      className="mb-4 flex flex-col gap-2 rounded-8 border border-destructive/40 bg-destructive/[0.06] px-4 py-3"
    >
      <p className="flex items-center gap-2 text-sm text-text-primary">
        <AlertTriangle aria-hidden className="size-4 shrink-0 text-destructive" />
        {clients.length === 1
          ? '1 client is over on variable hours this month'
          : `${clients.length} clients are over on variable hours this month`}
      </p>
      <ul className="flex flex-wrap gap-x-6 gap-y-1 pl-6">
        {clients.map((c) => (
          <li key={c.clientId}>
            <Link
              to={{ search: clientHref(c.clientId) }}
              aria-label={`Review ${c.name}’s ${formatHours(c.hours)} variable overage`}
              className="flex items-center gap-1 rounded-8 text-sm underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focus"
            >
              <span className="text-text-primary">{c.name}</span>
              <span className="tabular-nums text-destructive">+{formatHours(c.hours)}</span>
              <ChevronRight aria-hidden className="size-3 text-text-tertiary" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
